import { FunctionalComponent, h } from 'preact';
import { IconProps } from 'ui/icons/icon';

export const GlobeIcon: FunctionalComponent<IconProps> = (props) => {
	const { size = 18, fill = '#595959' } = props;

	return (
		<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 8.99999C16.5 4.85786 13.1421 1.49999 9 1.49999C4.85786 1.49999 1.5 4.85786 1.5 8.99999C1.5 13.1421 4.85786 16.5 9 16.5Z"
				stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path d="M1.5 9H16.5" stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path
				d="M9 1.49999C10.876 3.55376 11.9421 6.21902 12 8.99999C11.9421 11.781 10.876 14.4462 9 16.5C7.12404 14.4462 6.05794 11.781 6 8.99999C6.05794 6.21902 7.12404 3.55376 9 1.49999V1.49999Z"
				stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
};
